import React, {FC} from 'react';

import {AsyncHandlerOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {useAppDispatch, useAppSelector} from '../../../../../helpers/reduxHelpers';
import {getHasPrivateLens} from '../../../../../store/data/lenses/lensesSelectors';
import {createLensAsyncAction, LensTemplate} from '../../../../../store/data/lenses/saveLensActions';
import {getUserNamespace} from '../../../../../store/data/teammates/teammatesSelectors';
import {getUserTeams} from '../../../../../store/data/teams/teamsSelectors';
import {InboxesPanelId} from '../../../../../store/panels/panelStateBase';
import {LensUpdateHandler} from '../../editor/context/workspacesEditorContext';
import {LensesWorkspaceDialog, LensesWorkspaceDialogBaseProps} from './lensesWorkspaceDialog';

interface LensesWorkspaceCreateDialogProps
  extends Omit<LensesWorkspaceDialogBaseProps, 'userNamespace' | 'onSubmit'> {
  panelId: InboxesPanelId;
  workspaceUpdateHandler?: LensUpdateHandler;
}

export const LensesWorkspaceCreateDialog: FC<LensesWorkspaceCreateDialogProps> = (props) => {
  const userNamespace = useAppSelector(getUserNamespace);
  const hasPrivateLens = useAppSelector(getHasPrivateLens);
  const dispatch = useAppDispatch();
  const createLensAsync = (template: LensTemplate) =>
    dispatch(createLensAsyncAction({inboxesPanelId: props.panelId, template}, props.workspaceUpdateHandler));
  const onSubmit: AsyncHandlerOf<LensTemplate> = async (template) => {
    await createLensAsync(template);
  };

  const userTeams = useAppSelector(getUserTeams);
  const singleTeamNamespace = userTeams.length === 1 ? userTeams[0].namespace : undefined;

  return (
    <LensesWorkspaceDialog
      {...props}
      userNamespace={userNamespace}
      onSubmit={onSubmit}
      isEditing={false}
      baseNamespace={singleTeamNamespace}
      shouldShowInfoByDefault={!hasPrivateLens}
    />
  );
};
